import { FormEvent, useState, ChangeEvent, useRef } from "react";
import { useDispatch } from "react-redux";
import { sendMessage } from "../../../features/messageSlice";
import { useParams } from "react-router-dom";

const SendForm = () => {
  const { id } = useParams();
  const inputRef = useRef<HTMLInputElement>(null);

  const dispatch = useDispatch();
  const [messageState, setMessageState] = useState<string>("");

  const inputHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setMessageState(e.target.value);
  };

  const handleSubmitMessage = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const value = {
      receiverId: `${id}`,
      senderId: "1",
      message: {
        text: messageState,
        image: "",
      },
      status: {
        isDelivered: false,
        isSeen: false,
      },
      date: Date.now(),
    };
    if (messageState) {
      dispatch(sendMessage(value));
      inputRef.current?.focus();
      setMessageState("");
    }
  };

  return (
    <div className="w-full h-[100px] flex items-center sm:px-2 md:px-6">
      <form
        onSubmit={(e) => handleSubmitMessage(e)}
        className="bg-white p-2 rounded-md sm:h-[50px] md:h-[55px] shadow-md overflow-hidden flex item-center w-full"
      >
        <input
          type={"text"}
          placeholder="Type message here..."
          ref={inputRef}
          value={messageState}
          onChange={(e) => inputHandler(e)}
          className="outline-none flex-1 sm:px-1 md:px-4 sm:text-sm md:text-base"
        />
        <button
          type="submit"
          className="bg-violet-500 rounded-md sm:w-[70px] md:w-[100px] text-white h-full sm:text-sm md:text-base"
        >
          <i className="fa-regular fa-paper-plane text-white sm:text-sm md:text-base"></i>{" "}
          Send
        </button>
      </form>
    </div>
  );
};

export default SendForm;
